export const BearerToken = 'bearerToken'
export const OEMName = 'oemName'
export const DealerNumber = 'dealerNumber'
export const Channel = 'RezApi-TestDriveScheduler'
